
























































































































































import { Vue, Component, Prop } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { useThemeStore } from "@/shared/store/theme";
import { FamilyMember, FamilyMemberRelationship } from "@/shared/types";
import { useAuthorizedSignerStore } from "@/employee/store/authorizedSigner";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import * as Ssn from "@/shared/ssn";

@Component({
  components: {
    Button,
    GenericLoadingSpinner
  }
})
export default class EditDependent extends Vue {
  themeStore = useThemeStore();
  authorizedSignerStore = useAuthorizedSignerStore();
  hsabAccountsStore = useHsabAccountsStore();
  FamilyMemberRelationship = FamilyMemberRelationship;
  isSubmitting = false;
  currentSsn = "";
  isModalScrollable = false;

  @Prop({ required: true })
  dependent: FamilyMember;

  @Prop({ required: true })
  onSave: () => Promise<void>;

  @Prop()
  toggleClose: () => void;

  @Prop()
  isNew: boolean;

  @Prop()
  show: { value: boolean };

  get title () {
    return this.isNew ? "Add Dependent" : "Update Dependent Information";
  }

  get submitDisabled () {
    return !this.isValid || this.isSubmitting;
  }

  get isValid () {
    return !this.$validator.errors.any();
  }

  get isLoaded () {
    return  !this.userHasHsaAccount() || this.authorizedSignerStore.isAuthoriziedSignersLoaded;
  }

  get ssnTooltipMessage () {
    return "SSN cannot be updated for dependents who are also authorized signers.";
  }

  mounted () {
    this.currentSsn = this.dependent.ssn;

    if (this.userHasHsaAccount()) {
       this.authorizedSignerStore.loadAuthorizedSigners();
    }
    this.setModalScrollable();
    window.addEventListener("resize", this.setModalScrollable);
  }

  userHasHsaAccount () {
    return this.hsabAccountsStore.userHasHsaAccount;
  }

  isAuthorizedDependent () {
    return this.authorizedSignerStore.isAuthorizedSigner(this.currentSsn);
  }

  ssnMasked (): string {
    if (Ssn.isInvalid(this.dependent.ssn)) {
      return "";
    }
    return Ssn.lastFour(this.dependent.ssn);
  }

  onSsnChange (updatedSsn) {
    const updatedSsnMatchesWithAuthorizedSigner = this.authorizedSignerStore.isAuthorizedSigner(updatedSsn);
    if (updatedSsnMatchesWithAuthorizedSigner) {
      this.errors.add({field: "SSN/Tax ID", msg: this.errorMessageWhenSsnMatchesWithAuthorizedSigner });
    }
  }

  get errorMessageWhenSsnMatchesWithAuthorizedSigner () {
    const errorMessageWhileUpdatingDependent = "This SSN is associated with an existing Authorized Signer.";
    const errorMessageWhileAddingDependent = `${errorMessageWhileUpdatingDependent} Please add this dependent without an SSN.`;
    return this.isNew ? errorMessageWhileAddingDependent : errorMessageWhileUpdatingDependent;
  }

  save () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      this.isSubmitting = true;

      this.onSave().finally(() => {
        this.isSubmitting = false;
      });
    });
  }

  setModalScrollable () {
    const smallScreenMaxBreakpoint = 768;
    this.isModalScrollable = window.innerWidth < smallScreenMaxBreakpoint;
  }

  beforeDestroy () {
    window.removeEventListener("resize", this.setModalScrollable);
  }
}
